import { Component } from '@angular/core';

@Component({
  selector: 'app-lets-get-you-connected',
  imports: [],
  templateUrl: './lets-get-you-connected.component.html',
  styleUrl: './lets-get-you-connected.component.css'
})

export class LetsGetYouConnectedComponent {
  navigateToSignIn() {
    window.location.href = `${window.location.origin}/auth/logout?idp_logout=true`;
  }
}
